import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';

import useApplication from './useApplication';
import RenderIf from '../../renderIf';
import Section from './section';
import ApplicationContext from './ApplicationContext';
import Markdown from './markdown';
import BackButton from '../../backButton';
import ShipyardMenuButton from '../../shared/shipyardMenu';
import { ChangeStatus } from './actionModals';

const AdminApplication = (props) => {
    const { state: dashboardState } = useLocation();
    const appInstId = props.match.params.applicationId;
    const {
        isInitialized,
        application,
        doingAjax,
        forceReload,
        selectedAction,
        retrieveApp,
        updateAnswer,
        handleStatusChange,
        setSelectedAction,
    } = useApplication(appInstId);

    const history = useHistory();

    React.useEffect(() => {
        retrieveApp();
    }, []);

    return (
        <Box>
            <Box
                sx={{
                    marginLeft: '2rem',
                }}
            >
                <BackButton
                    text="Back to applications"
                    onClick={() => {
                        let newDashboardState = { ...dashboardState };
                        if (forceReload) newDashboardState = { ...newDashboardState, list: [], recOffset: 0 };
                        history.push('/applications', newDashboardState);
                    }}
                />
            </Box>

            <RenderIf isTrue={isInitialized}>
                <ChangeStatus
                    open={selectedAction === 'ChangeStatus'}
                    currentStatus={application?.appInstance?.statusId}
                    handleClose={handleStatusChange}
                    appInstId={appInstId}
                />

                <Box
                    sx={{
                        marginLeft: '2rem',
                    }}
                >
                    <Markdown variant="h1">{application?.appDef?.name?.['en-US']}</Markdown>
                </Box>

                <Paper
                    sx={{
                        margin: '2rem',
                        padding: '1rem',
                        borderRadius: '8px',
                    }}
                >
                    <ApplicationContext.Provider value={{ updateAnswer }}>
                        {application?.appDef?.sections?.map?.((section, i) => (
                            <Section
                                section={section}
                                appInstId={appInstId}
                                key={`section-${i}`}
                            />
                        ))}
                    </ApplicationContext.Provider>
                </Paper>

                <Paper
                    sx={{
                        margin: '2rem 0 0',
                        padding: '1rem',
                        display: 'flex',
                        justifyContent: 'right',
                        position: 'sticky',
                        bottom: 0,
                        borderRadius: 0,
                    }}
                    elevation={2}
                >
                    <ShipyardMenuButton
                        label="Select Action"
                        actions={[
                            {
                                label: 'Change status',
                                action: () => setSelectedAction('ChangeStatus'),
                            },
                        ]}
                        icon={<FontAwesomeIcon icon={faAngleDown} />}
                        disabled={doingAjax}
                    />
                </Paper>
            </RenderIf>

            <RenderIf isTrue={!isInitialized}>
                <Typography
                    variant="h1"
                    sx={{
                        margin: '2rem',
                    }}
                >
                    Retrieving application <span style={{ color: '#014E8D' }}>information</span>...
                </Typography>
            </RenderIf>
        </Box>
    );
};

export default AdminApplication;
